exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supplier-marker-icon{z-index:99999!important;-webkit-transform-origin:50% 50%!important;transform-origin:50% 50%!important}.supplier-extra{position:fixed;bottom:16px;right:16px;z-index:999;background-color:#fff;padding:10px;min-width:150px;font-size:12px;text-align:right}", ""]);

// exports
